import React from 'react';
import { useDispatch } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { ModalProps, DealType } from '../../store/types/types';
import { deactivateStart } from '../../store/deactivate/deactivate.actions';
import StyledBox from './deactivate-modal.styles';

const DeactivateConfirmModal = ({ isOpen, handleClose, messageId, programmatic }: ModalProps & DealType) => {
    let message = null;
    const dispatch = useDispatch();

    const handleDeactivate = () => {
        handleClose();
        dispatch(deactivateStart({ messageId, programmatic }));
    };

    if (programmatic) {
        message = "Accepting this request will update the FreeWheel Creative approval status to 'PENDING'";
    } else {
        message = "Accepting this request will deactivate the FreeWheel Creative and/or Placement";
    }

    return (
        <React.Fragment>
            <Modal
                aria-labelledby="deactivate-modal-title"
                aria-describedby="deactivate-modal-description"
                open={isOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>
                <Fade in={isOpen}>
                    <StyledBox>
                        <Typography
                            id="deactivate-modal-title"
                            sx={{ fontSize: 24, fontWeight: "bold" }}
                        >
                            CONFIRM DEACTIVATION
                        </Typography>
                        <Typography
                            id="deactivate-modal-description"
                        >
                            {message}
                        </Typography>
                        <Button
                            onClick={handleDeactivate}
                            variant="contained"
                            size="medium"
                            color="primary"
                            sx={{ mt: 3 }}
                        >
                            DEACTIVATE
                        </Button>
                    </StyledBox>
                </Fade>
            </Modal>
        </React.Fragment>
    );
}

export default DeactivateConfirmModal;